import { useState, useEffect } from "react";
import { Sidebar } from "./Sidebar";
import { Overview } from "./Overview";
import { MasterAdmin } from "./MasterAdmin";
import { CrmBoard } from "./CrmBoard";
import { CouponsAdmin } from "./CouponsAdmin";
import { PendingActivations } from "./PendingActivations";
import { DoctorsAdmin } from "./DoctorsAdmin";
import { RepassesReport } from "./RepassesReport";
import { INITIAL_CUSTOMERS } from "@/data/backofficeData";

const TITLES = {
  overview: { title: "Visão Geral", sub: "Métricas do negócio em tempo real" },
  customers: { title: "Clientes Ativos", sub: "Gestão de assinantes VeloClin (Master Admin)" },
  activations: { title: "Ativações", sub: "Contas pagas aguardando validação do CRM e ativação manual" },
  doctors: { title: "Médicos & Clínicas", sub: "Gestão de assinaturas: autorize ou bloqueie o acesso, exclua cadastros e veja dados e mensalidades" },
  repasses: { title: "Repasses", sub: "Histórico de vendas, faturamento mensal/anual e rentabilidade de cada médico e clínica para a VeloClin" },
  crm: { title: "CRM & Vendas", sub: "Funil comercial e comunicação omnichannel" },
  coupons: { title: "Cupons de Desconto", sub: "Crie, ative/desative e acompanhe quem usa cada cupom" },
};

export const BackofficeShell = ({ userEmail, token, onLogout }) => {
  const [active, setActive] = useState("overview");
  const [customers, setCustomers] = useState(INITIAL_CUSTOMERS);
  const [leads, setLeads] = useState([]);
  const head = TITLES[active];

  useEffect(() => {
    if (!token) return;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/backoffice/leads`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json()).then((d) => setLeads(d.leads || [])).catch(() => {});
  }, [token]);

  return (
    <div className="flex min-h-screen flex-col bg-[#F8FAFC] lg:flex-row" data-testid="backoffice-shell">
      <Sidebar active={active} onChange={setActive} onLogout={onLogout} userEmail={userEmail} />

      <main className="flex-1 overflow-x-hidden">
        <header className="sticky top-0 z-10 border-b border-slate-200 bg-white/80 px-5 py-4 backdrop-blur lg:px-8 lg:py-5">
          <h1 className="font-heading text-lg font-extrabold tracking-tight text-slate-900 lg:text-xl">{head.title}</h1>
          <p className="text-sm text-slate-500">{head.sub}</p>
        </header>

        <div className="p-5 lg:p-8">
          {active === "overview" && <Overview customers={customers} leads={leads} />}
          {active === "customers" && <MasterAdmin customers={customers} setCustomers={setCustomers} />}
          {active === "crm" && <CrmBoard leads={leads} setLeads={setLeads} token={token} />}
          {active === "coupons" && <CouponsAdmin token={token} />}
          {active === "activations" && <PendingActivations token={token} />}
          {active === "doctors" && <DoctorsAdmin token={token} />}
          {active === "repasses" && <RepassesReport token={token} />}
        </div>
      </main>
    </div>
  );
};
